module.exports = __webpack_public_path__ + "assets/img/img-hotel-09.e1f2bd55.jpg";